import React from 'react';
import { Card, CardTitle, Option, Input, withGrid, CardContent, Select } from '../../../Components';
import { ProfessorModel } from '../../../Store/Professor';
import { observer } from 'mobx-react';
import { ValidationError } from '../../../Store';
import styled from 'styled-components';
import { media } from '../../../Themes';
import { HelpButton } from '../../Shared/HelpButton';

interface IProfCardProps extends React.InputHTMLAttributes<any> {
  professores: Array<ProfessorModel>;
  handleProfessorSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => any;
  membro: ProfessorModel;
  validation: ValidationError<ProfessorModel>;
  disabled?: boolean;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const SelectGrid = InputGrid.withComponent(Select);

const StlyedHelpButton = styled(HelpButton)`
  margin: 0px 5px
`;

@observer
export default class ProfessorCard extends React.Component<IProfCardProps> {
  cardRef: React.RefObject<HTMLDivElement>;

  constructor(props: IProfCardProps) {
    super(props);
    this.cardRef = React.createRef();
  }

  render() {
    const { professores, membro, validation } = this.props;

    return (
      <Card ref={this.cardRef}>
        <CardTitle>
          Membro da Banca - Convidar
          <StlyedHelpButton>
            A partir de 01/02/2020 as bancas são compostas por dois docentes: orientador e convidado
          </StlyedHelpButton>
        </CardTitle>
        <CardContentGrid>
          <SelectGrid
            gridColumn='1/13'
            name='nome'
            label='Nome'
            type='text'
            value={(professores.find(p => p.nome === membro.nome)
              && professores.find(p => p.nome === membro.nome)!.id) || 0}
            onChange={this.props.handleProfessorSelectChange}
            disabled={this.props.disabled}
            hasError={validation && validation.nome}
            errorMessage={validation && validation.nome}
          >
            <Option value={0} key={0}> Selecione... </Option>
            {professores.filter(p => p.ativoBanca == true).map(p => (
              <Option value={p.id} key={p.id}>
                {p.nome}
              </Option>
            ))}
          </SelectGrid>
        </CardContentGrid>
      </Card>
    );
  }
}
